import { useMemo } from 'react';
import { Container, Typography, Button, Box, styled } from '@mui/material';
import { motion } from 'framer-motion';
import { hoverEffect } from '../constants/animations';

const GradientText = styled(Typography)(({ theme }) => ({
    background: 'linear-gradient(45deg, #d9262d 0%, #ff5e5a 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    display: 'inline',
    fontWeight: 700,
}));

// Language content configuration
const content = {
    EN: {
        title: "UNICORN BEAUTY BUSINESS SCHOOL",
        subtitle: "A Beauty Entrepreneurs' Education Platform",
        region: "Southeast Asia Region",
        since: "Since 2017",
        cta: "Explore Our Programs"
    },
    BM: {
        title: "UNICORN BEAUTY BUSINESS SCHOOL",
        subtitle: "Platform Pendidikan Pengusaha Kecantikan",
        region: "Wilayah Asia Tenggara",
        since: "Sejak 2017",
        cta: "Jelajahi Program Kami"
    },
    CN: {
        title: "独角兽美业商学院",
        subtitle: "美业企业家教育平台",
        region: "东南亚地区",
        since: "自2017年起",
        cta: "探索我们的课程"
    }
};

const HeroSection = ({ language = 'EN' }) => {
    const memoizedHoverEffect = useMemo(() => hoverEffect, []);
    const currentContent = content[language] || content.EN;

    return (
        <Box
            component={motion.section}
            {...memoizedHoverEffect}
            sx={{
                textAlign: 'center',
                py: { xs: 8, sm: 12, md: 15 },
                px: 2,
                backgroundImage: "url(/images/cover.jpg)",
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '100vh',
                width: '100%'
            }}
        >
            <Container maxWidth="md">
                <Typography variant="h1" component="h1" gutterBottom>
                    {currentContent.title}
                </Typography>
                <Typography variant="h4" gutterBottom>
                    {currentContent.subtitle}
                </Typography>
                <Typography variant="h6" sx={{ mb: 4 }}>
                    {currentContent.region} | {currentContent.since}
                </Typography>
                <Button variant="contained" size="large">
                    {currentContent.cta}
                </Button>
            </Container>
        </Box>
    );
};

export default HeroSection;